import template from './api-endpoints.template.html';
import controller from './api-endpoints.controller';

const apiEndpointsComponent = {
  template,
  controller,
  controllerAs: 'apiEndpointsCtrl'
};

export default apiEndpointsComponent;



// WEBPACK FOOTER //
// ./ui/src/components/api-endpoints/api-endpoints.component.js